export default __webpack_public_path__ + "static/media/franchinsing-symbol.8de4bfee.svg";